import React, { useState } from 'react';
import { Formik, FieldArray } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';
import { SelectDropDown, Label } from 'pages/ViewSingleRequest/styles';
import {
  AcademicForm,
  ConsentSection,
  RoundedButton,
  AddSection,
  FormFooter
} from '../styles';
import Container from 'components/common/Container';
import { renameFileUpload } from 'utils/renameUploadUtils';

import { Form, InputContainer } from 'pages/Admin/Clients/styles';
import { svgs } from 'assets';

import { olevelValidationSchema } from 'helpers/validators';
import { Error } from '../../Signin/styles';
import FormUploader from 'components/Uploader';
import Button from 'components/common/Button';
import { CREATE_OLEVEL } from 'graphql/resolvers/admin/candidates/mutations';
import { toastSuccess, toastError } from 'components/common/Toast';
import Loader from 'components/common/Loader';

import { fileDownloader } from './../../../helpers/fileDownloader';

const Olevel = ({
  nextTab,
  prevTab,
  index,
  setNewinfo,
  newInfo,
  savedData,
  fileName,
  ...rest
}) => {
  const [showLoader, setLoaderState] = useState(false);
  const [createOlevelRequest] = useMutation(CREATE_OLEVEL);

  const handleOnSubmit = async (values) => {
    const payload = [];
    setLoaderState(true);
    for (let i = 0; i < values.olevelDetails.length; i++) {
      const response = createOlevelRequest({
        variables: {
          verificationRequest: localStorage.getItem('verificationId'),
          id: values.olevelDetails?.[i].id ? values.olevelDetails?.[i].id : null,
          examName: values.olevelDetails?.[i].examName,
          examNumber: values.olevelDetails?.[i].examNumber,
          type: values.olevelDetails?.[i].type,
          year: values.olevelDetails?.[i].year,
          certificate: values.olevelDetails?.[i].certificate
        }
      });
      payload.push(response);
    }
    const results = await Promise.allSettled(payload);

    const dataLoads = [];

    results.forEach(({ status, value, reason }) => {
      if (status === 'fulfilled') {
        dataLoads.push(value.data.createOlevelRequest.olevel);
      }
    });

    const olevelDetails = dataLoads?.length
      ? dataLoads.map((level) => ({
          id: level.id,
          certificate: level.certificate,
          examName: level.examName,
          examNumber: level.examNumber,
          year: level.year,
          type: level.type
        }))
      : [];

    setNewinfo((prev) => ({
      ...prev,
      olevel: {
        olevelDetails
      }
    }));

    if (dataLoads.length) {
      toastSuccess(svgs.SUCCESS_ICON, 'Olevel Request Created Successfully');
      nextTab(index);
    } else {
      toastError(svgs.DELETE_ICON, 'An error has occured');
    }

    setLoaderState(false);
  };

  return (
    <Formik
      initialValues={{
        olevelDetails:
          newInfo?.olevel?.olevelDetails.length || savedData.length
            ? newInfo?.olevel?.olevelDetails || savedData
            : [
                {
                  id: '',
                  certificate: '',
                  examName: '',
                  examNumber: '',
                  year: '',
                  type: ''
                }
              ]
      }}
      validationSchema={olevelValidationSchema}
      onSubmit={handleOnSubmit}
      render={({
        values,
        errors,
        touched,
        handleReset,
        setFieldValue,
        handleSubmit,
        handleChange,
        handleBlur
      }) => {
        return (
          <Container>
            <AcademicForm professional>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <FieldArray
                  name="olevelDetails"
                  render={({ insert, remove, push }) => (
                    <>
                      {values.olevelDetails.length > 0 &&
                        values.olevelDetails.map((level, index) => (
                          <div key={index} style={{ padding: '30px' }}>
                            <InputContainer>
                              <label htmlFor="callNumber">School Type</label>
                              <div style={{ marginLeft: '1.2rem' }}>
                                <SelectDropDown
                                  name={`olevelDetails.${index}.type`}
                                  width="100%"
                                  onChange={handleChange}
                                  value={values.olevelDetails?.[index].type}
                                >
                                  <option>{'Select School type'}</option>
                                  <option value="PRIVATE">PRIVATE</option>
                                  <option value="SCHOOL">SCHOOL </option>
                                </SelectDropDown>
                                {touched?.olevelDetails?.[index]?.type &&
                                errors?.olevelDetails?.[index]?.type ? (
                                  <Error>{errors?.olevelDetails?.[index]?.type}</Error>
                                ) : null}
                              </div>
                            </InputContainer>
                            <InputContainer>
                              <label htmlFor="callNumber">Examination Name</label>
                              <div style={{ marginLeft: '1.2rem' }}>
                                <SelectDropDown
                                  name={`olevelDetails.${index}.examName`}
                                  width="100%"
                                  onChange={handleChange}
                                  value={values.olevelDetails?.[index].examName}
                                >
                                  <option>{'Select Examination type'}</option>
                                  <option value="WAEC">WAEC</option>
                                  <option value="NECO">NECO </option>
                                  <option value="NABTEB">NABTEB</option>
                                </SelectDropDown>
                                {touched?.olevelDetails?.[index]?.examName &&
                                errors?.olevelDetails?.[index]?.examName ? (
                                  <Error>
                                    {errors?.olevelDetails?.[index]?.examName}
                                  </Error>
                                ) : null}
                              </div>
                            </InputContainer>
                            <InputContainer>
                              <label htmlFor="examNumber ">Examination Number</label>
                              <input
                                id="examNumber"
                                name={`olevelDetails.${index}.examNumber`}
                                type="text"
                                placeholder="Examination Number"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.olevelDetails?.[index].examNumber}
                                className={`InputElement ${
                                  touched?.olevelDetails?.[index]?.examNumber &&
                                  errors?.olevelDetails?.[index]?.examNumber
                                    ? 'Invalid'
                                    : ''
                                }`}
                              />
                              {touched?.olevelDetails?.[index]?.examNumber &&
                              errors?.olevelDetails?.[index]?.examNumber ? (
                                <Error>
                                  {errors?.olevelDetails?.[index]?.examNumber}
                                </Error>
                              ) : null}
                            </InputContainer>
                            <InputContainer>
                              <label>Examination Date</label>
                              <input
                                name={`olevelDetails.${index}.year`}
                                placeholder="Examination Year"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.olevelDetails?.[index].year}
                                type="date"
                                className={`InputElement ${
                                  touched?.olevelDetails?.[index]?.year &&
                                  errors?.olevelDetails?.[index]?.year
                                    ? 'Invalid'
                                    : ''
                                }`}
                              />
                              {touched?.olevelDetails?.[index]?.year &&
                              errors?.olevelDetails?.[index]?.year ? (
                                <Error>{errors?.olevelDetails?.[index]?.year}</Error>
                              ) : null}
                            </InputContainer>

                            <InputContainer>
                              <label htmlFor="">School Certificate</label>
                              <FormUploader
                                form
                                accept={[
                                  'application/pdf',
                                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                  'image/png',
                                  'image/jpg',
                                  'image/jpeg'
                                ]}
                                className={
                                  touched?.olevelDetails?.[index]?.certificate &&
                                  errors?.olevelDetails?.[index]?.certificate
                                    ? 'Invalid'
                                    : ''
                                }
                                handleUpload={(files) => {
                                  const modifiedFile = files[0];
                                  // const modifiedFile = renameFileUpload(
                                  //   file,
                                  //   fileName || 'Olevel_Certificate'
                                  // );
                                  setFieldValue(
                                    `olevelDetails.${index}.certificate`,
                                    modifiedFile
                                  );
                                }}
                                text="Upload File"
                                file={values?.olevelDetails?.[index]?.certificate}
                              />
                              {touched?.olevelDetails?.[index]?.certificate &&
                              errors?.olevelDetails?.[index]?.certificate ? (
                                <Error>
                                  {errors?.olevelDetails?.[index]?.certificate}
                                </Error>
                              ) : null}
                            </InputContainer>
                            <AddSection>
                              <AddSection>
                                {index > 0 && (
                                  <button
                                    className="text-red"
                                    bgColor="transparent"
                                    textColor="#000"
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    REMOVE
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => {
                                    push({
                                      certificate: '',
                                      examName: '',
                                      year: '',
                                      type: ''
                                    });
                                  }}
                                >
                                  + Add Olevel
                                </button>
                              </AddSection>
                            </AddSection>
                          </div>
                        ))}
                    </>
                  )}
                />
                <FormFooter>
                  <Button backbutton type="button" onClick={() => prevTab(index)}>
                    Back
                  </Button>
                  <Button type="submit" disabled={showLoader ? true : false}>
                    {showLoader ? (
                      <div style={{ textAlign: 'center' }}>
                        <Loader />
                      </div>
                    ) : (
                      'Next'
                    )}
                  </Button>
                </FormFooter>
              </Form>
            </AcademicForm>
          </Container>
        );
      }}
    />
  );
};

export default Olevel;
